<template>
  <div class="ui-empty-state empty-state">
    <div v-if="icon" class="ui-empty-state__icon empty-state-icon">{{ icon }}</div>
    <div class="ui-empty-state__text empty-state-text">
      <slot name="title">{{ title }}</slot>
    </div>
    <div v-if="hint || $slots.hint" class="ui-empty-state__hint empty-state-hint">
      <slot name="hint">{{ hint }}</slot>
    </div>
    <div v-if="actionLabel || $slots.action" class="ui-empty-state__action">
      <slot name="action">
        <AppButton v-if="actionLabel" :label="actionLabel" variant="primary" @click="$emit('action')" />
      </slot>
    </div>
  </div>
</template>

<script>
import AppButton from './AppButton.vue';

export default {
  name: 'EmptyState',
  components: {
    AppButton,
  },
  props: {
    icon: {
      type: String,
      default: '📋',
    },
    title: {
      type: String,
      default: 'No items found',
    },
    hint: {
      type: String,
      default: '',
    },
    actionLabel: {
      type: String,
      default: '',
    },
  },
  emits: ['action'],
};
</script>

<style src="../styles/EmptyState.css"></style>
